import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LinkInformationSettingTemplateBlacklist } from '../interfaces/link-information-setting-template-blacklist.interface';

@Injectable({
	providedIn: 'root'
})
export class LinkInformationSettingTemplateBlacklistService {
	readonly url: string = 'linkInformationSettingTemplateBlacklist';

	constructor(private http: HttpClient) { }

	public getAll(): Observable<LinkInformationSettingTemplateBlacklist[]> {
		return this.http.get<LinkInformationSettingTemplateBlacklist[]>(this.url);
	}

	public create(entity: LinkInformationSettingTemplateBlacklist): Observable<LinkInformationSettingTemplateBlacklist> {
		return this.http.post<LinkInformationSettingTemplateBlacklist>(this.url, entity)
	}

	public delete(linkInformationId: number, settingTemplateId: number) {
		return this.http.delete(this.url + '/' + linkInformationId + '/' + settingTemplateId);
	}

}
